import { useState } from 'react';

function useTenantDetail() {
  const [activeTab, setActiveTab] = useState('about');

  const handleChange = (event, selectedTab) => {
    setActiveTab(selectedTab);
  };

  return {
    activeTab,
    handleChange,
  };
}

export default useTenantDetail;
